import { lazy } from "react";

const MainPage = lazy(() => import("./page"));

const routes = [
  {
    path: "/management/diagnostic",
    component: MainPage,
    exact: false,
    name: "Relación de Enfermedades - CIE"
  }
];

export default routes;
